<template>
  <div>
    <input
      ref="fileInput"
      accept="image/jpeg, application/pdf"
      class="d-none"
      type="file"
      name="doc"      
      @change="selectFile($event)"
    />
    <div class="row">
      <div class="col-md-9">
        <div class="w-100 border h-100">
          <input
            class="form-control w-100"
            type="text"
            v-model="fileSelected.name"
            v-if="fileSelected !== null"
            readonly
          />
        </div>
      </div>
      <div class="col-md-3">
        <button
          class="btn btn-sm btn-outline-warning btn-gr float-right my-auto"
          @click="$refs.fileInput.click()"
        >
          <i class="fa fa-file" aria-hidden="true"></i>
          &nbsp;{{$t('seleccionar')}}
        </button>
      </div>
    </div>
    <div class="row pt-1">
      <div class="col-md-9">
        <select class="w-100" v-model="documentType" v-if="!fileLoading">
          <option v-for="doc in docTypes.data" :key="doc.id" :value="doc.id">{{ $t(doc.name) }}</option>
        </select>
      </div>
      <div class="col-md-3">
        <!--  <button v-if="fileSelected !== null && documentType !== null" 
        class="btn btn-sm btn-outline-primary btn-gr float-right my-auto" @click="upload">
          <i class="fa fa-upload" aria-hidden="true"></i>
          &nbsp;{{$t('enviar')}}
        </button>-->
        <vue-loading-button
          class="btn btn-sm btn-outline-primary btn-enviar my-auto float-right"
          @click.native="upload"
          :loading="fileLoading"
          :styled="false"
        >
        <i class="fa fa-upload" aria-hidden="true"></i>&nbsp;
        {{ $t('enviar') }}</vue-loading-button>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-12">
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import VueLoadingButton from "vue-loading-button";

export default {
  props: ["dogId"],
  name: "upload-file",
  components: { VueLoadingButton },
  data() {
    return {
      fileSelected: null,
      documentType: null,      
    };
  },
  methods: {
    ...mapActions("files", ["uploadFile", "getTypeDocList"]),
    selectFile: function(event) {
      this.fileSelected = event.target.files[0];
      // this.upload();
    },
    upload(e) {
      //this.setFileData(this.fileSelected, 10, this.documentType);
      e.preventDefault();
      let dataUpload = {
        file: this.fileSelected,
        dogId: this.dogId,
        docType: this.documentType
      };

      console.log(dataUpload);
      this.uploadFile(dataUpload);
    }
  },
  computed: {
    ...mapState("files", ["fileLoading", "docTypes"])
  
  }, 
  mounted() {
    this.getTypeDocList()
    .then(res => {
      console.log(res)

    });
  }
};
</script>

<style scoped>
input {
  background-color: aliceblue!important;
  height: 29px!important;
  /* line-height: 14px !important; */
  background-color: white!important;
}
select {
  background-color: aliceblue;
  height: 29px !important;
  padding: 2px 2px 2px 20px;
  border: 1px solid #949494;
  /*margin:2px 2px 2px 2px; */
}


button.vue-loading-button  {   
  font-size: 11px!important;
  font-family: "Montserrat", sans-serif!important;
  text-transform: uppercase!important ; 
  text-align:center!important;
  height:29px!important;
  min-width:125px!important;

}
button > span.spinner {  
  right:2rem!important;
  top:10px!important;
}
  

</style>